import React, { useContext } from 'react';
import IconButton, { IconButtonProps } from '../../v2BaseComponents/IconButton';
import { AudioRecordingContext } from './AudioRecordingContainer';

export type PromptAudioButtonOwnProps = {};

export type PromptAudioButtonProps = PromptAudioButtonOwnProps & Partial<IconButtonProps>;

const PromptAudioButton: React.FC<PromptAudioButtonProps> = (props) => {
    const audioRecordingContext = useContext(AudioRecordingContext);
    return (
        <IconButton
            {...props}
            variant="small-record-button"
            icon="Mic"
            onPress={audioRecordingContext.openRecorder}
            isDisabled={props.isDisabled}
            testID="prompt-audio-recording"
        />
    );
};

export default React.memo(PromptAudioButton);
